<template>
  <div>
    <h5 class="text-primary mt-4">CAMBIO DE PRODUCTOR / ORGANIZADOR</h5>
    <b-tabs class="mt-4">
      <!-- Productor -->
      <b-tab title="Productor">
        <b-row>
          <b-col>
            <b-form-group label="Código:">
              <b-form-input
                type="text"
                v-model="productor.codigo"
                @blur="$v.productor.codigo.$touch"
                :state="$v.productor.codigo.$dirty ? !$v.productor.codigo.$error : null"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Nombre:">
              <b-form-input
                type="text"
                v-model="productor.nombre"
                @blur="$v.productor.nombre.$touch"
                :state="$v.productor.nombre.$dirty ? !$v.productor.nombre.$error : null"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-tab>

      <!-- Organizador -->
      <b-tab title="Organizador">
        <b-row>
          <b-col>
            <b-form-group label="Código:">
              <b-form-input
                type="text"
                v-model="organizador.codigo"
                @blur="$v.organizador.codigo.$touch"
                :state="$v.organizador.codigo.$dirty ? !$v.organizador.codigo.$error : null"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Nombre:">
              <b-form-input
                type="text"
                v-model="organizador.nombre"
                @blur="$v.organizador.nombre.$touch"
                :state="$v.organizador.nombre.$dirty ? !$v.organizador.nombre.$error : null"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>

    <!-- Comentarios adicionales -->
    <b-card style="border-radius: 0" class="mt-2">
      <b-card-text>
        <b-textarea rows="3" placeholder="Comentarios adicionales" v-model="comentarios" @blur="$v.comentarios.$touch" :state="$v.comentarios.$dirty ? !$v.comentarios.$error : null" />
      </b-card-text>
    </b-card>

    <!-- Form Footer -->
    <div class="submit-footer">
      <b-row>
        <b-col class="text-right">
          <b-btn
            variant="success"
            @click="submit"
            v-b-tooltip.hover
            title="La presente solicitud está sujeta a aprobación. Los cambios no se guardarán de manera instantánea."
          >
            <i class="fa fa-send-o" v-if="!sending"></i>
            <i class="fa fa-spinner fa-spin" v-else></i>

            Enviar Solicitud
          </b-btn>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Autocomplete from '@/components/Autocomplete';
import { required, requiredIf } from 'vuelidate/lib/validators';
export default {
  components: {
    Autocomplete
  },
  props: ['tomador', 'nroPoliza'],
  data() {
    return {
      sending: false,
      productor: {
        codigo: '',
        nombre: ''
      },
      organizador: {
        codigo: '',
        nombre: ''
      },
      comentarios: ''
    };
  },
  validations: {
    productor: {
      codigo: {
        required: requiredIf(function() {
          return this.productor.nombre.length || this.allEmpty;
        })
      },
      nombre: {
        required: requiredIf(function() {
          return this.productor.codigo.length || this.allEmpty;
        })
      }
    },
    organizador: {
      codigo: {
        required: requiredIf(function() {
          return this.organizador.nombre.length || this.allEmpty;
        })
      },
      nombre: {
        required: requiredIf(function() {
          return this.organizador.codigo.length || this.allEmpty;
        })
      }
    },
    comentarios: { required }
  },
  methods: {
    submit: async function() {
      this.$v.$touch();

      if (this.$v.$invalid) {

        return null;
      }

      this.sending = true;

      await this.$api.post(`endoso/solicitud/cambio-productor/${this.tomador}`, {
        pas: {
          nombre: (this.$store.state.auth.nombre + ' ' + this.$store.state.auth.apellido).replace('null',''),
          codigo: this.$store.state.auth.cod_agente,
          email: this.$store.state.auth.email
        },
        poliza: this.nroPoliza,
        productor: this.productor,
        organizador: this.organizador,
        comentarios: this.comentarios
      })
        .then(() => {
          this.$toast.success('Solicitud de endoso por cambio de productor / organizador enviada.');
        })
        .catch(err => {
          //console.log(err.response);
          this.$toast.error('Ocurrió un error al enviar la solicitud');
        });

      this.sending = false;
    }
  },
  computed: {
    productores() {
      return this.$store.getters['productores'];
    },
    organizadores() {
      return this.$store.getters['productores']; // TODO: cambiar esto por organizadores
    },
    allEmpty() {
      return !Object.values(this.productor).some(p => p) && !Object.values(this.organizador).some(o => o)
    }
  }
};
</script>
